import { SiteLinks } from "interfaces";
import { useMemo } from "react";
import useLiveopsConfigs from "./useLiveopsConfigs";

const configIds = [
	"app_store_icon_image_url",
	"back_to_game_url",
	"tos_url",
	"privacy_url",
	"forum_url",
	"social_instagram_url",
	"social_facebook_url",
	"social_twitter_url",
	"faq_url"
];

export const useLinks = (): SiteLinks => {
	const configs = useLiveopsConfigs(configIds);

	const links = useMemo<SiteLinks>(
		() => ({
			back_to_game: {
				path: configs["back_to_game_url"],
				title: "Back to Game",
				analytics_key: "click_back_to_game",
				isExternal: true,
				target: "_blank"
			},
			tos: {
				path: configs["tos_url"],
				title: "Terms of Service",
				analytics_key: "terms_of_service_click",
				isExternal: true
			},
			privacy: {
				path: configs["privacy_url"],
				title: "Privacy Policy",
				analytics_key: "privacy_policy_click",
				isExternal: true
			},
			privacy_ads_toggle: {
				path: "/privacy-ads-toggle",
				title: "Do Not Sell or Share My Personal Information",
				analytics_key: "ads_toggle_page_click"
			},
			forum: {
				path: configs["forum_url"],
				title: "Forum",
				description: "Connect with other players.",
				analytics_key: "forum_section_click",
				isExternal: true
			},
			appstore_apple: {
				path: configs["app_store_icon_image_url"],
				title: "iOS App Store",
				analytics_key: "appstore_apple_click",
				isExternal: true
			},
			appstore_google: {
				path: configs["app_store_icon_image_url"],
				title: "Google Play Store",
				analytics_key: "appstore_google_click",
				isExternal: true
			},
			social_facebook: {
				path: configs["social_facebook_url"],
				title: "Facebook",
				analytics_key: "social_facebook_click",
				isExternal: true
			},
			social_twitter: {
				path: configs["social_twitter_url"],
				title: "Twitter",
				analytics_key: "social_twitter_click",
				isExternal: true
			},
			social_instagram: {
				path: configs["social_instagram_url"],
				title: "Instagram",
				analytics_key: "social_instagram_click",
				isExternal: true
			},
			faq: {
				title: "FAQ",
				path: configs["faq_url"],
				analytics_key: "faq_section_click",
				description: "Have questions? Find answers.",
				isExternal: true
			},
			merch_shop: {
				path: "/merch-shop",
				title: "Merch Shop",
				description: "Our Official Merchandise Shop.",
				analytics_key: "web_merch_shop_section_click"
			},
			news: {
				path: "/news",
				title: "News",
				description: "Stay Up to Date with Our Latest News, Updates!",
				analytics_key: "news_section_click"
			},
			home: {
				path: "/",
				title: "Home",
				description: "Tiki Solitaire TriPeaks homepage.",
				analytics_key: "home_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_home"
			},
			winners: {
				path: "/winners",
				title: "Winners",
				description: "Celebrate the Champions of Tiki Solitaire TriPeaks.",
				analytics_key: "winners_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_winners"
			},
			shop: {
				path: "/shop",
				title: "Shop",
				description: "The one-stop-shop.",
				analytics_key: "shop_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_web_shop"
			},
			pois_bounty: {
				path: "/pois-bounty",
				title: "Poi's Bounty",
				description: "Collect rewards from Poi.",
				analytics_key: "pois_bounty_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_pois_bounty"
			},
			club_shop: {
				path: "/club-shop",
				title: "Club Shop",
				description: "Shop for your Club.",
				analytics_key: "club_shop_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_club_shop"
			},
			loyalty: {
				path: "/loyalty-shop",
				legacyPaths: ["/loyalty", "/loyalty-points"],
				title: "Loyalty Shop",
				description: "Be Rewarded for Your Loyalty.",
				analytics_key: "loyalty_shop_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_loyalty_shop"
			},
			free_daily_gifts: {
				path: "/free-daily-gifts",
				title: "Free Daily Gifts",
				description: "Claim DAILY GIFTS with Your 7-Day Gift Streak!",
				analytics_key: "daily_gift_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_daily_free_gift"
			},
			club_free_gift: {
				path: "/club-free-gift",
				title: "Club Free Gift",
				description: "A free daily gift for your whole club.",
				analytics_key: "club_free_gift_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_club_free_gift"
			},
			drip_offer: {
				path: "/special-offers",
				title: "Special Offers",
				description: "Extra Prizes available for a Limited Time.",
				analytics_key: "special_offer_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_drip_offer"
			},
			friend_center: {
				path: "/friend-center",
				title: "Friend Center",
				description: "Send gifts and invite friends.",
				analytics_key: "friend_center_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_friend_center"
			},
			elite_deals: {
				path: "/elite-deals",
				title: "Elite Deals",
				description: "Exclusive offers",
				analytics_key: "elite_deals_section_click",
				mega_menu_sale_tag_event_name: "mega_menu_tag_elite_deals"
			},
			sign_up_scopely: {
				path: "",
				title: "Sync your progress",
				description:
					"Sign up for Scopely account to stay updated with the latest offers, exclusive deals AND get a Bonus Reward.",
				analytics_key: "",
				isExternal: true
			}
		}),
		[configs]
	);

	return links;
};
